<template>
  <div class="root">
    <div class="login viqqa-callback">
      <div class="flex items-center text-center text-2xl">
        <h3>{{ $root.config.appName }}</h3>
      </div>

      <div v-if="!error" class="viqqa-callback-wait">
        <vk-spinner ratio="1" />
        <p>{{ waitText }}</p>
      </div>

      <div v-else class="viqqa-callback-error">
        <p class="font-semibold">{{ errorTitle }}</p>
        <p class="text-sm mt-2">{{ error }}</p>
        <a :href="backHref" class="uk-button uk-button-default mt-4">
          {{ backText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "../services/auth";

// Viqqa OAuth dönüş sayfası (VIQQA_REDIRECT_URI buraya işaret eder).
// Hem "Viqqa ile giriş" hem de Profil'den "Viqqa hesabını bağla" akışı buraya
// döner; hangisi olduğunu sunucu state'ten bilir.
export default {
  name: "viqqa-callback",
  data() {
    return {
      error: null,
      linking: false
    };
  },
  computed: {
    waitText() {
      return this.linking
        ? "Viqqa hesabı doğrulanıyor…"
        : "Viqqa ile giriş doğrulanıyor…";
    },
    errorTitle() {
      return this.linking
        ? "Viqqa hesabı bağlanamadı"
        : "Viqqa ile giriş yapılamadı";
    },
    backHref() {
      return this.linking ? "/profile" : "/login";
    },
    backText() {
      return this.linking ? "Profile dön" : "Giriş sayfasına dön";
    }
  },
  created() {
    // Akışı başlatan sayfa sessionStorage'a yazar ("login" / "link"); yoksa
    // oturum token'ı olup olmamasına bakılır. Sadece metinleri etkiler.
    let flow = null;
    try {
      flow = sessionStorage.getItem("viqqaFlow");
      sessionStorage.removeItem("viqqaFlow");
    } catch (e) {
      flow = null;
    }
    this.linking = flow ? flow === "link" : !!localStorage.getItem("authToken");

    const q = this.$route.query || {};
    const str = v => (typeof v === "string" ? v : "");

    if (q.error) {
      this.error =
        str(q.error_description) ||
        (q.error === "access_denied"
          ? "İzin verilmedi."
          : "Viqqa bir hata döndürdü: " + str(q.error));
      return;
    }

    const code = str(q.code);
    const state = str(q.state);
    if (!code || !state) {
      this.error = "Geçersiz dönüş adresi.";
      return;
    }

    // code tek kullanımlık: adres çubuğundan ve geçmişten temizle.
    try {
      window.history.replaceState(null, "", window.location.pathname);
    } catch (e) {
      // yoksay
    }

    AuthService.viqqaCallback(code, state)
      .then(resp => {
        const data = resp.data || {};
        if (data.success && data.token) {
          localStorage.setItem("authToken", data.token);
          window.location.href = "/";
          return;
        }
        if (data.success && data.linked) {
          window.location.href = "/profile?viqqa=linked";
          return;
        }
        this.error = data.msg || "İşlem tamamlanamadı.";
      })
      .catch(() => {
        this.error = "Crm erişim sorunu";
      });
  }
};
</script>

<style>
.viqqa-callback-wait,
.viqqa-callback-error {
  margin-top: 24px;
  text-align: center;
}

.viqqa-callback-wait p {
  margin-top: 12px;
}
</style>
